import { Component, OnInit, ViewChild, ChangeDetectorRef, TemplateRef } from '@angular/core';
import { MatPaginator, MatSort, MatTableDataSource, MatDialog , PageEvent, MatTable, MatStepper} from '@angular/material';
import { environment } from 'src/environments/environment';
import { CreateBillModalComponent } from './create-bill-modal/create-bill-modal.component';
import { Subscription } from 'rxjs';
import { Messages } from '../constants/messages';
import { HttpService } from '../http.service';
import { EventService } from '../event.service';
import { StorageService } from '../storage.service';
import { Router } from '@angular/router';
import { TimeService } from '../time.service';
import { STEPPER_GLOBAL_OPTIONS } from '@angular/cdk/stepper';

import { DateTime } from 'luxon';
import { InvoiceHistoryComponent } from './invoice-history/invoice-history.component';
import { ShipmentDetailsComponent } from '../dashboardModals/shipment-details/shipment-details.component';
import { SnackbarService } from '../snackbar.service';
import { ValidationService } from '../validation.service';
import { TranslateService } from '@ngx-translate/core';
import { CreditNoteComponent } from '../bills/credit-note/credit-note.component';


export interface Invoice {
  id: string;
  invocie_date: string;
  shipment_id: string;
  shipment_date: string;
  enterprise_name: string;
  unit_name: string;
  bill_cycle: string;
  amount: number;
  invoice_pdf: string;
  include: boolean;
}

// write interface for invoice filters

@Component({
  selector: 'app-create-bill',
  templateUrl: './create-bill.component.html',
  styleUrls: ['./create-bill.component.scss'],
  providers: [{
    provide: STEPPER_GLOBAL_OPTIONS, useValue: { displayDefaultIndicatorType: false }
  }]
})

export class CreateBillComponent implements OnInit {
  // displayColumns = ['include', 'id', 'enterprise_name', 'unit_name','amount','invoice_pdf'];
  displayColumns = ['include', 'id', 'enterprise_name', 'pickup_delivery', 'pickup_delivery_date', 'status_date', 'amount', 'actions'];
  invoiceArray: any = [];
  selectedInvoices = [];
  rejectedInvoices = [];
  shippersArray = [];

  showTransitType = environment.country != 'SA';

  ////
  generateModalType = 'bulk';
  generateModalRef;
  generateBillIds;
  @ViewChild('generateBillModal', {static: true}) generateBillModal: TemplateRef<any>;
  selectedShipperId;
  disableSelectAll = false;

  ///////
  selectedTransitType: any;
  totalInvoices = 0;
  totalAmount;
  selectedShipper: any;
  selectedStatus: any = {
    status: 'APPROVED'
  };

  transit_types = [
    {
      name: 'Inter-State',
      value: 'INTER'
    },
    {
      name: 'Intra-State',
      value: 'INTRA'
    },
  ];
  enableCreateBillButton = false;
  currencySymbol;
  invoices: any = [];
  invoicesList: MatTableDataSource<Invoice>;
  @ViewChild(MatTable, {static: true}) table: MatTable<any>;
  @ViewChild('stepper1', {static: false}) private myStepper: MatStepper;

  @ViewChild(MatPaginator, {static: true}) paginator: MatPaginator;
  @ViewChild(MatSort, {static: true}) sort: MatSort;

  status_data = {
    approved: { value: '', loader: false },
    disapproved: { value: '', loader: false },
    pending: { value: '', loader: false },
    billed: { value: '', loader: false },
    no_of_ready_for_payment:{ value:'',loader:false},
    no_of_payment_paid:{ value:'',loader:false}
  };

  invoiceFilters: any = {
    shipper: '',
    from: Date,
    to: Date,
    skip: 0,
    limit: 0,
    transit_type: '',
    status: 'APPROVED'
  };

  date_filter: any = {
    from_date: Date,
    to_date: Date,
  };

  selectStatusArray = {
    approved: true,
    disapproved: false,
    pending: false,
    billed: false,
    no_of_ready_for_payment:false,
    no_of_payment_paid:false,
  };
  isShipperSelected = false;
  select_all = false;
  shipmentDetails;
  showLoader = false;
  spinner = false;
  showStatus = 'Approved';


  dateTime: any = {
    from_date: Date,
    to_date: Date,
    min: '',
    max: ''
  };
  helpData = [
    { head: 'Head', data: 'Lorem Ipsum is simply dummy text of the printing and typesetting industry. Lorem Ipsum has been the industry' },
    { head: 'Head', data: 'Lorem Ipsum is simply dummy text of the printing and typesetting industry. Lorem Ipsum has been the industry' },
  ];
  carrierUpdates: Subscription;
  errors = new Messages();
  constructor(private router: Router, private translation: TranslateService, private dialog: MatDialog, private http: HttpService, private events: EventService, private storage: StorageService, private route: Router, public timeService: TimeService, private snackbar: SnackbarService, private valid: ValidationService) {
    const access_token = this.storage.getFromCookie('access_token');
    if (!access_token) {
      this.route.navigateByUrl('login');
    }
  }

  ngOnInit() {
    this.setTime();
    this.getShippers();
    const currency = JSON.parse(localStorage.getItem('carriers'));
    this.currencySymbol = currency[0].country.currency.symbol;
    this.carrierUpdates = this.events.getCarrierIdChanges().subscribe(
      (data: any) => {
        this.getShippers();
      }
    );
  }

  // get the shipper to populate the enterpise unit filter
  getShippers() {
    this.showLoader = true;
    this.shippersArray = [];
    this.http.get('shippers', {mode: 'BILLING'}).subscribe(
      (data: any) => {
      this.showLoader = false;
      if (data.statusCode == 200) {
          this.shippersArray = [
            {
              id: '',
              parent_name: 'All'
            }
          ];
          data.data.forEach((element) => {
            this.shippersArray.push({
              id: element._id,
              name: element.name,
              location: element.location,
              parent_name: element.parent_name
            });
          });
          this.selectShipper(this.shippersArray[0]);
        }
      }
    );
  }

   // set the time in the date picker
  setTime() {
    this.date_filter.from_date = ( d => new Date(d.setDate(d.getDate() - 30)) )(new Date); // sets the from date to 30 days before date
    this.date_filter.from_date.setHours(0, 0, 0, 0); // set hours to 12:00AM
    this.date_filter.to_date = new Date(); // set the to_date to today's date
    this.date_filter.to_date.setHours(23, 59, 59, 0);
    this.invoiceFilters.from = this.timeService.toUTCEpoch(this.date_filter.from_date);
    this.invoiceFilters.to = this.timeService.toUTCEpoch(this.date_filter.to_date);
    this.date_filter.min = this.date_filter.from_date;
    this.date_filter.max = this.date_filter.to_date;
  }

  ngOnDestroy() {
    this.carrierUpdates.unsubscribe();
  }
  closeGenerateBillModal(data) {
    this.generateModalRef.close(data);
  }

  // select invoice status
  selectInvoiceStatus(status, type) {
    if (type === 'pending') {
      this.showStatus = 'Pending';
   }
    if (type === 'billed') {
     this.showStatus = 'Billed';
   }
    if (type === 'approved') {
     this.showStatus = 'Approved';
   }
    if (type === 'disapproved') {
     this.showStatus = 'Disapproved';
   }
   if(type ==='no_of_ready_for_payment'){
    this.showStatus = 'No_Of_Ready_For_Payment'
   }
   if(type === 'no_of_payment_paid'){
    this.showStatus = 'No_Of_Payment_Paid'
   }
    this.selectStatusArray = {
      approved: false,
      disapproved: false,
      pending: false,
      billed: false,
      no_of_ready_for_payment:false,
      no_of_payment_paid:false,
    };
    this.select_all = false;
    this.selectedInvoices = [];
    this.enableCreateBillButton = false;
    this.selectStatusArray[type] = true;
    this.selectedStatus.status = status;
    this.invoiceFilters.status = this.selectedStatus.status;
    this.getInvoices(this.invoiceFilters);
  }

  getInvoices(filter: any = {}) {
    filter.limit =  this.paginator.pageSize || 25;
    filter.skip = this.paginator.pageIndex * (this.paginator.pageSize || filter.limit);
    this.showLoader = true;
    this.status_data.approved.loader = true;
    this.status_data.billed.loader = true;
    this.status_data.disapproved.loader = true;
    this.status_data.pending.loader = true;
    this.status_data.no_of_ready_for_payment.loader=true;
    this.status_data.no_of_payment_paid.loader=true;
    this.showLoader = true;


    if (environment.country == 'SA') {
      delete filter.transit_type;
    }
    this.http.get('carrier_invoice/get_all', filter, 1).subscribe(
      (data: any) => {
        if ( data.statusCode == 200) {
          this.showLoader = false;
          // invoice stats
          this.status_data.approved.loader = false;
          this.status_data.billed.loader = false;
          this.status_data.disapproved.loader = false;
          this.status_data.pending.loader = false;
          this.status_data.no_of_ready_for_payment.loader=false;
          this.status_data.no_of_payment_paid.loader=false;
          this.status_data.approved.value = data.data.stats.no_of_approved ;
          this.status_data.disapproved.value = data.data.stats.no_of_disapproved ;
          this.status_data.pending.value = data.data.stats.no_of_pending;
          this.status_data.billed.value = data.data.stats.no_of_billed;
          this.status_data.no_of_ready_for_payment.value=data.data.stats.no_of_ready_for_payment;
          this.status_data.no_of_payment_paid.value=data.data.stats.no_of_payment_paid;

          // invoices
          this.invoiceArray = data.data.invoices ? data.data.invoices : [];
          this.totalInvoices = data.data.count ? data.data.count : 0;
          this.totalAmount = data.data.final_amount ? data.data.final_amount.toFixed(2) : 0;
          this.invoices = [];
          this.invoiceArray.forEach(element => {
            const temp: any = {};
            temp.id = element._id;
            temp.IINC =  element.IINC.custom ?  element.IINC.custom : element.IINC.default;
            temp.invoice_date = this.timeService.toShortDateTime(element.created_at);
            temp.SIN = element.shipment.SIN;
            temp.shipment_id = element.shipment._id;
            temp.shipment_date = this.timeService.toShortDateTime(element.shipment.finished_at);
            temp.amount = Math.trunc(element.final_amount);
            temp.is_verified = element.is_verified;
            temp.is_deleted = element.is_deleted;
            temp.is_billed = element.is_billed;
            temp.bill_no = (element.carrier_bill && element.carrier_bill.CBIN) ? (element.carrier_bill.CBIN.custom ? element.carrier_bill.CBIN.custom : (element.carrier_bill.CBIN.default ? element.carrier_bill.CBIN.default : 'N / A') ) : 'N / A';
            // temp.amount = element.final_amount.toFixed(0);
            temp.enterprise_name = element.shipper_info.enterprise;
            temp.unit_name = element.shipper_info.unit;
            temp.invoice_pdf = element.IINC;
            temp.invoice_link = element.pdf_link;
            temp.status = element.status;
            temp.approved_at = element.approved_at ? this.timeService.toShortDate(element.approved_at) : '';
            temp.pickups = element.shipment.pickups;
            temp.deliveries = element.shipment.deliveries;
            temp.onlyPickupDrop = [temp.pickups[0], temp.deliveries[temp.deliveries.length - 1]];
            temp.allLocationsData = temp.pickups.concat(temp.deliveries);
            temp.stepperIndex = temp.allLocationsData.length + 10;
            temp.shipperId = element.shipper;
            temp.shipper_info = element.shipper_info;
            temp.carrier_info = element.carrier_info;
            temp.client_info = element.client_info;
            temp.bill_to_info = element.bill_to_info;
            temp.additional_charges = element.additional_charges;
            temp.deductible_charges = element.deductible_charges;
            temp.created_at = element.created_at ? this.timeService.toShortDate(element.created_at) : '';
            temp.final_amount = element.final_amount.toFixed(2);
            temp.final_amount_words = element.final_amount_words;
            temp.initial_amount = element.initial_amount;
            temp.materials = element.materials;
            temp.pre_tax_amount = element.pre_tax_amount.toFixed(2);
            temp.shipment = element.shipment;
            temp.sub_total = element.sub_total;
            temp.tax_amount = element.tax_amount;
            temp.total_additional_charges = element.total_additional_charges ? element.total_additional_charges.toFixed(2) : 0;
            temp.total_deductible_charges = element.total_deductible_charges ? element.total_deductible_charges.toFixed(2) : 0;
            temp.vehicle_name = element.vehicle_name;
            temp.vehicle_no = element.vehicle_no;
            temp.currency = element.currency;
            temp.discount = element.discount;
            temp.total_nop = element.total_nop;
            temp.tax_type = element.tax_type;
            temp.transit_type = element.transit_type;
            temp.URD = element.URD;
            temp.GTAtoGTA = element.GTAtoGTA;
            temp.gross_weight = element.weight ? element.weight.gross : '';
            temp.net_weight = element.weight ? element.weight.net : '';
            temp.measure_unit = element.weight ? element.weight.measure_unit : '';
            temp.annexure = element.annexure;
            temp.advance_amount = element.advance_amount ? element.advance_amount.toFixed(2) : 0;
            temp.terms_conditions = element.terms_conditions || '';
            temp.logo = element.logo || '';
            temp.waybill = element.ref_lr_id || '';
            temp.sac_code = element.sac_code || '';
            temp.rate_type = element.rate ? element.rate.type : '';
            temp.rate_sub_type = element.rate ? element.rate.sub_type : '';
            temp.price_per_unit = element.price_per_unit ?  element.price_per_unit : 0;
            temp.purchase_order = element.purchase_order ? element.purchase_order : '';
            temp.net_payable_amount = element.net_payable_amount ? element.net_payable_amount.toFixed(2) : 0;
            temp.ref_number = element.ref_number ? element.ref_number : '';
            // temp.pod = true;total_nop: 0

            // set the checkbox for the invoice
            temp.include = false;
            temp.expand = false;
            this.invoices.push(temp);
          });
          if (!this.invoicesList) {
            this.invoicesList = new MatTableDataSource(this.invoices);
            this.invoicesList.sort = this.sort;
            this.invoicesList.paginator = this.paginator;
            this.paginator._intl.itemsPerPageLabel = this.translation.instant('CREATE_BILLS.pagination_label');
          } else {
            this.invoicesList = new MatTableDataSource(this.invoices);
            this.paginator._intl.itemsPerPageLabel = this.translation.instant('CREATE_BILLS.pagination_label');
          }
        }
      },
      (err: any) => {
        this.showLoader = false;
        this.invoices = [];
        this.invoicesList = new MatTableDataSource(this.invoices);
        this.invoicesList.sort = this.sort;
        this.invoicesList.paginator = this.paginator;
        this.status_data.approved.loader = false;
        this.status_data.billed.loader = false;
        this.status_data.disapproved.loader = false;
        this.status_data.pending.loader = false;
        this.status_data.no_of_ready_for_payment.loader =false;
        this.status_data.no_of_payment_paid.loader = false;
        this.status_data.approved.value = '--';
        this.status_data.disapproved.value = '--';
        this.status_data.pending.value =  '--';
        this.status_data.billed.value = '--';
        this.status_data.no_of_ready_for_payment.value = '--';
        this.status_data.no_of_payment_paid.value ='--';
        this.paginator._intl.itemsPerPageLabel = this.translation.instant('CREATE_BILLS.pagination_label');
      }
    );
  }

  pageNavigate(event: PageEvent) {
    this.invoiceFilters.limit = event.pageSize;
    this.invoiceFilters.skip = event.pageIndex * event.pageSize;
    this.select_all = false; // set select all checkbox to false (as per the condition in SRS)
    this.selectAll({checked: this.select_all}); // empty all the selected_invoices if present
    this.getInvoices(this.invoiceFilters);
  }

  applyFilter(value) {

  }

    // set the from_date when selected from the date picker
  setFromDateTime(value) {
    this.date_filter.from_date = value.from_date;
    const t1 = DateTime.fromJSDate(value.from_date).toFormat('dd/MM/yyyy 00:00:00');
    const epoch: any = DateTime.fromFormat(t1, 'dd/MM/yyyy 00:00:00'); // get the epoch time
    this.invoiceFilters.from = epoch.ts;
    this.invoiceFilters.to = this.timeService.toUTCEpoch(this.date_filter.to_date);
    this.getInvoices(this.invoiceFilters);
    this.date_filter.min = this.date_filter.from_date;
  }

  // set to_date to the value set from the date picker
  setToDateTime(value) {
    this.date_filter.to_date = value.to_date;
    this.date_filter.to_date.setHours(23, 59, 59, 0);
    const t1 = DateTime.fromJSDate(value.to_date).toFormat('dd/MM/yyyy hh:mm:ss a');
    const epoch: any = DateTime.fromFormat(t1, 'dd/MM/yyyy hh:mm:ss a');
    this.invoiceFilters.to = epoch.ts;
    this.invoiceFilters.from = this.timeService.toUTCEpoch(this.date_filter.from_date);
    this.getInvoices(this.invoiceFilters);
    this.date_filter.max = this.date_filter.to_date;
  }

  // select the shipper and get invoices based on the selected shipper
  selectShipper(shipper) {
    this.isShipperSelected = true;
    this.selectedShipper = shipper;
    (shipper.id) ? this.invoiceFilters.shipper = shipper.id : delete this.invoiceFilters.shipper;
    this.selectTransitType(this.transit_types[0]);
    // this.getInvoices(this.invoiceFilters);
  }

  // to clear filters
  clearFilter() {
    this.setTime();
    this.selectShipper(this.shippersArray[0]);
    this.selectedInvoices = [];
    this.enableCreateBillButton = false;
  }

  // triggered when select button is enabled or disabled
  include(event, element) {
    if (event.checked) {// if the individual checkbox is selected
      element.include = event.checked; // set the row value to value of checkbox
      this.selectedInvoices.push(element); // push the element to selected_invoices array

      // check if all the invoices in the page are selected
      let all_selected = this.invoicesList.data.filter((element) => {
        return element.include == true;
      });

      if(this.select_all || all_selected.length >= 1 && this.showStatus == 'Approved') {
        this.enableCreateBillButton = true;
      } else {
        this.enableCreateBillButton = false;
      }

      if (all_selected.length == this.invoicesList.data.length) {// if the last_selected has length 0
        this.select_all = true; // set select all checkbox to true
        this.enableCreateBillButton = true;
      }
    } else {
      // set select all checkbox to false if select all checkbox is true and one of the indidual checkbox is set to false
      this.select_all = false;
      element.include = event.checked;
      this.selectedInvoices = this.selectedInvoices.filter((e) => {// remove unchecked invoice from the selected invoice array
        if (e.id == element.id) {
        // add the unchecked id to rejectedInvocies
          this.rejectedInvoices.push(e.id);
        }
        return e.id !== element.id;
      });
      // check if all the invoices in the page are unselected
      let all_selected = this.invoicesList.data.filter((element) => {
        return element.include == true;
      });

      if (all_selected.length < 2) {
        this.enableCreateBillButton = false;
      }
    }
  }

  // triggered when select all checkbox is changed
  selectAll(event) {
    this.select_all = event.checked; // holds the value of the checkbox
    this.enableCreateBillButton = true;
    if (event.checked) {// if select all checkbox is true
      this.invoicesList.data.forEach((element) => {// set all the indidual checkbox to true
        element.include = true;
      });
      this.selectedInvoices = []; // clear selected invoices
      this.selectedInvoices = this.invoicesList.data; // all the invoices are selected invoices
    } else {// if select all checkbox is false
    this.enableCreateBillButton = false;
    this.invoicesList.data.forEach((element) => {// set all the indidual checkbox to false
        element.include = false;
      });
    this.selectedInvoices = []; // empty the selected invoices array
    }
  }

  // redirect to shipment dashboard
  openShipmentDashboard(ev: Event, type) {
    this.router.navigateByUrl(`shipmentsDashboard/${type}`);
    ev.stopPropagation();
  }

  // open Invoice history modal
  openInvoiceHistory(data) {
    this.dialog.open(InvoiceHistoryComponent, {
      data
    });
  }

  // create bill
  createBill() {
    const request = {
      invoice_ids: this.generateBillIds,
      shipper: this.selectedShipperId,
      transit_type: this.selectedTransitType.value
    };
    // this.showLoader = true;
    this.spinner = true;
    this.http.post('carrier_bill/create', request, 1).subscribe(
      (data: any) => {
        // this.showLoader = false;
        this.spinner = false;
        if (data.statusCode == 200) {
          this.snackbar.openSnackBar(this.translation.instant('MESSAGE.CREATE_BILLS.SUCCESS.BILLS'));
        } else {
          this.snackbar.openSnackBar(data.message || this.translation.instant('MESSAGE.CREATE_BILLS.ERROR.ERR'), 'err');
        }
        this.closeGenerateBillModal(data);
      },
      err => {
        this.spinner = false;
        this.snackbar.openSnackBar(err.error.message, '', 'err');
        this.closeGenerateBillModal(err);
      }
    );
  }

  regenerateInvoice(data) {
    data.generateFreight = false;
    this.openShipmentDetails(data, 6);
  }

  openShipmentDetails(element, tabI= 0) {
    this.http.get('shipment/one?shipmentId=' + element.shipment_id).subscribe(
      (data: any) => {
        if (data.statusCode === 200) {
          this.shipmentDetails = data.data;
          this.shipmentDetails.generateFreight = element.generateFreight;
          this.shipmentDetails.tabIndex = tabI;
          const dialogRef = this.dialog.open(ShipmentDetailsComponent, {
            data: this.shipmentDetails,
            width: '1250px',
            maxWidth: '95vw !important'
          });
          dialogRef.afterClosed().subscribe(result => {
            this.shipmentDetails = {};
          });
        }
      },
      (err: any) => {
        this.snackbar.openSnackBar(err.error.message, '', 'err');
        if (err.error.statusCode == 401) {
          this.valid.logout();
        }
      }
    );
  }

  bulkGenerate() {
    this.generateBillIds = this.selectedInvoices.map(e => e.id);
    this.generateModalType = 'bulk';
    this.generateBill(this.generateBillIds, '');
  }

  openInvoicePreview(element) {
    this.storage.setToLocalStorage('Invoice', JSON.stringify(element));
    this.route.navigateByUrl('preview');
  }

  generateBill(ids, shipperId) {
    this.generateBillIds = ids;
    this.selectedShipperId = this.selectedShipper.id ? this.selectedShipper.id : shipperId._id;
    this.generateModalRef  = this.dialog.open(this.generateBillModal);
    this.generateModalRef.afterClosed().subscribe(result => {
      if (result.statusCode == 200) {
        this.selectedShipperId = '';
        this.generateBillIds = [];
        this.selectedInvoices = [];
        this.getInvoices(this.invoiceFilters);
        this.enableCreateBillButton = false;
      }
    });
  }

  selectTransitType(transit_type) {
      this.selectedTransitType = transit_type;
      this.invoiceFilters.transit_type = this.selectedTransitType.value;
      this.getInvoices(this.invoiceFilters);
  }
}
